export default {
  title:           'Outros direitos',
  description:     'Descadastramento comunicações Marketing',
  email_sms_label: 'Descadastrar-se de futuras ofertas especiais e promoções por e-mail ou SMS.',
  whatsapp_label:  'Deixar de receber informações por <strong>WhatsApp</strong> sobre minha conta Simplic.',
  disclaimer:      'As preferências acima se referem a comunicações relacionadas a novos empréstimos.\n As comunicações e atualizações relacionadas a empréstimos atuais continuarão até a quitação dos mesmos.',
};
